import {event} from '../modules/event';
import {ajax} from '../modules/ajax';
import {Form} from '../modules/Form';
import {CommentsItem} from '../modules/CommentsItem';


/*
* Не используется как отдельный модуль
* Отвечает за форму в комментариях
* */

var CommentsForm = class {
	constructor(wrapper, CommentsObj) {
		this._createElements(wrapper, CommentsObj);
		this._addEvents();
	}
	
	_createElements(wrapper, CommentsObj){
        var self = this;
		this.wrapper = wrapper;
        this.CommentsObj = CommentsObj;
        this.forForm = this.wrapper.querySelector('[data-CommentsForm-forForm]');
        this.formBox = this.wrapper.querySelector('[data-CommentsForm-formBox]');
        this.writeBtn = this.wrapper.querySelector('[data-CommentsForm-writeBtn]');
		this.smileBtn = this.wrapper.querySelector('[data-CommentsForm-smileBtn]');
        this.textarea = this.wrapper.querySelector('[data-CommentsForm-textarea]');
		this.smileBox = this.wrapper.querySelector('[data-CommentsForm-smileBox]');
        this.answerField = this.wrapper.querySelector('[data-CommentsForm-answerField]');
        this.emojiAll = this.smileBox.querySelectorAll('.emoji');
        this.successBox = this.wrapper.querySelector('[data-CommentsForm-susccess]');
        this.commentItemObj = false; /* если нажимаем на ответить в коменте, ответ нужно вставить сразу за ним и форму вниз */
        this.moduleAll = APP.modules.run(this.wrapper, 'data-commentsForm-modules');
        this.formObj = new Form({
            wrapper:this.formBox,
            onsuccess:function(data){
                //location.replace(location.protocol + '//' + location.host + location.pathname);
                var comment; /* блок с коментом */

                self.formObj.resetCaptcha();
                self.formObj.resetForm();

                /* если это ответ */
                /*if(self.commentItemObj){
                    self.commentItemObj.wrapper.insertAdjacentHTML("afterEnd", data.message);
                    comment = self.commentItemObj.wrapper.nextElementSibling;
                } else {
                    self.wrapper.insertAdjacentHTML("beforeBegin", data.message);
                    comment = self.wrapper.previousElementSibling;
                }*/

                self.wrapper.insertAdjacentHTML("beforeBegin", data.message);
                comment = self.wrapper.previousElementSibling;

                var newComment = self.CommentsObj.addNewComment(comment);
                newComment.forForm.appendChild(self.successBox);
                var cls = self.successBox.className;
                if(cls.indexOf(' js-disabled') !== -1) self.successBox.className = cls.replace(' js-disabled', '');

                /* если это ответ */
                if(self.commentItemObj) {
                    var offset = newComment.wrapper.getBoundingClientRect().top - self.commentItemObj.wrapper.getBoundingClientRect().bottom;
                    self._onClickWriteBtn.call(self, false);
                    window.scrollBy(0, offset);
                }

                // analyticts
                self._sendStat();
            },
            onerror:function(data){
                self.formObj.resetCaptcha();
                uPopup({
                    content:data.message
                });
            }
        });
    }
    _sendStat(){
        try {
            gtag('event', 'send_form', {
                'event_category': 'engagement',
                'event_label': 'leave_comment'
            });
            console.log('gtag success!');
        } catch (error){
            console.error('gtag error:', error);
        }
    }
	_addEvents(){
		var self = this;

		event.add(this.smileBtn, 'click', function(){
			if(self.smileBox.className.indexOf('js-active') === -1) {
				self.smileBox.className = self.smileBox.className + ' js-active';
			}
			else self.smileBox.className = self.smileBox.className.replace(/\s*js-active/, '');
		});

        event.add(this.smileBox, 'scroll', function(e){
            e.stopPropagation();
        });

        this.writeBtn.addEventListener('click', function(e){
            self._onClickWriteBtn.call(self, e);
        }, false);

        for(var i=0,j=this.emojiAll.length; i<j; i++){
            event.add(this.emojiAll[i], 'click', function(){
                self.textarea.value = self.textarea.value + ' ' + this.firstChild.nodeValue + ' ';
                self.textarea.focus();
            })
        }
	}

    _onClickWriteBtn(e){
        /* если нет события - значит мы просто возвращаем форму на место после ответа */
        if(e) e.preventDefault();
        var cls = this.writeBtn.className;
        this.writeBtn.className = cls + ' js-disabled';
        this.answerField.value = '';
        this.forForm.appendChild(this.formBox);
        if(e) this.textarea.focus();
        this.commentItemObj = false;
    }

    onClickAnswerBtn(commentItemObj){
        var commentUid = commentItemObj.param.uid,
            wrapper = commentItemObj.forForm,
            writeBtnCls = this.writeBtn.className;

        //
        if(writeBtnCls.indexOf(' js-disabled') !== -1) this.writeBtn.className = writeBtnCls.replace(' js-disabled', '');

        this.answerField.value = commentUid;
        wrapper.appendChild(this.formBox);
        this.textarea.focus();

        this.commentItemObj = commentItemObj;
    }

    del(){
        this.formObj.del();
        APP.modules.destroy(this.moduleAll);
    }
};

export {CommentsForm};





































